import { z } from "zod"

// `invalidEmail` is a locale-free error code that the render site (SsoEmailForm)
// maps onto a next-intl translation. Keeps the schema reusable on the server
// without binding it to a specific locale's English copy.
export const ssoEmailSchema = z.object({
  email: z.string().email({ message: "invalidEmail" }),
})

export type SsoEmailInput = z.infer<typeof ssoEmailSchema>
